export const translations = {
  roles: {
    Администратор: 'Адміністратор',
    Бухгалтер: 'Бухгалтер',
    Кассир: 'Касир',
    Инкассатор: 'Інкасатор'
  }
};
